module.exports = __webpack_public_path__ + "static/media/english.c7ef7aee.png";